module.exports = "pegasus_template/assets/blocks/image-4-theme4.png";